import React from "react";
import CommonCountryInput from "../../common/inputs/CommonCountryInput";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import CommonTextAreaInput from "../../common/inputs/CommonTextAreaInput";

const VISA_TYPES = [
  { code: "VisaFree", label: "Visa Free" },
  { code: "VisaOnArrival", label: "Visa On Arrival" },
  { code: "eVisa", label: "eVisa" },
  { code: "VisaRequired", label: "Visa Required" },
  { code: "eTA", label: "eTA" },
  { code: "FreedomOfMovement", label: "Freedom of Movement" },
  { code: "NotAdmitted", label: "Not Admitted" },
];

function TransitVisaForm({ form, setForm }) {
  const update = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleRequiresTransitVisa = (value) => {
    const yes = value === true;
    setForm((prev) => ({
      ...prev,
      requiresTransitVisa: yes,
      transitVisaType: yes
        ? // if switching to YES and type is empty or VisaFree -> default VisaRequired
          prev.transitVisaType && prev.transitVisaType !== "VisaFree"
          ? prev.transitVisaType
          : "VisaRequired"
        : // when NO, always VisaFree
          "VisaFree",
    }));
  };

  const handleRequiresDestinationVisa = (value) => {
    const yes = value === true;
    setForm((prev) => ({
      ...prev,
      requiresDestinationVisa: yes,
      destinationVisaType: yes
        ? prev.destinationVisaType && prev.destinationVisaType !== "VisaFree"
          ? prev.destinationVisaType
          : "VisaRequired"
        : "VisaFree",
    }));
  };

  return (
    <div className="flex flex-col gap-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <CommonCountryInput
          label="Origin Country"
          value={form.originCountry}
          onChange={(v) => update("originCountry", v)}
          placeholder="Select country"
        />

        <CommonCountryInput
          label="Transit Country"
          value={form.transitCountry}
          onChange={(v) => update("transitCountry", v)}
          placeholder="Select country"
        />

        <CommonCountryInput
          label="Destination Country"
          value={form.destinationCountry}
          onChange={(v) => update("destinationCountry", v)}
          placeholder="Select country"
        />

        <CommonCountryInput
          label="Passport Nationality"
          value={form.passportNationality}
          onChange={(v) => update("passportNationality", v)}
          placeholder="Select nationality"
        />

        <CommonDropdownInput
          label="Requires Transit Visa?"
          options={[
            { code: true, label: "Yes" },
            { code: false, label: "No" },
          ]}
          optionObject
          value={form.requiresTransitVisa}
          onChange={handleRequiresTransitVisa}
          placeholder="Select option"
        />

        {form.requiresTransitVisa && (
          <CommonDropdownInput
            label="Transit Visa Type"
            options={VISA_TYPES}
            optionObject
            value={form.transitVisaType}
            onChange={(v) => update("transitVisaType", v)}
            placeholder="Select visa type"
          />
        )}

        <CommonDropdownInput
          label="Requires Destination Visa?"
          options={[
            { code: true, label: "Yes" },
            { code: false, label: "No" },
          ]}
          optionObject
          value={form.requiresDestinationVisa}
          onChange={handleRequiresDestinationVisa}
          placeholder="Select option"
        />

        {form.requiresDestinationVisa && (
          <CommonDropdownInput
            label="Destination Visa Type"
            options={VISA_TYPES}
            optionObject
            value={form.destinationVisaType}
            onChange={(v) => update("destinationVisaType", v)}
            placeholder="Select visa type"
          />
        )}
      </div>

      <CommonTextAreaInput
        label="Notes"
        value={form.notes}
        onChange={(v) => update("notes", v)}
        placeholder="Add any notes..."
      />
    </div>
  );
}

export default TransitVisaForm;
